// src/dashboard/components/TableFeedback.js

import React from 'react';

export const LoadingSpinner = ({ styles, isContained = false }) => (
    <div className={styles.loadingSpinnerContainer} data-contained={isContained}>
        <div className={styles.spinner}></div>
        <p>Carregando dados...</p>
    </div>
);

export const ErrorMessage = ({ error, styles }) => (
    <tr><td colSpan="3" className={`${styles.textCenter} ${styles.py4} ${styles.textRed}`}>{error?.message || 'Ocorreu um erro ao buscar os dados.'}</td></tr>
);

export const NoDataMessage = ({ styles }) => (
    <tr><td colSpan="3" className={`${styles.textCenter} ${styles.py4}`}>Nenhum dado encontrado para os filtros selecionados.</td></tr>
);